export const STORAGE_KEY_AUTH = "current_auth";
export const STORAGE_KEY_LOGIN = "current_login";
export const STORAGE_KEY_USER = "current_user";
export const STORAGE_KEY_LANG = "current_lang";
export const USER_EVENT_CHANGE = 'user:change';
export const SYNC_STATUS_PENDING="pending";
export const SYNC_STATUS_FAILED="failed";
export const SYNC_STATUS_SUCCESS="success";
